let sprintf = require("sprintf-js").sprintf;
let Str = require('string');

let stripTags = (str) => Str(str).stripTags().s;

let devotion = (promised) => {
    let running = false;
    return function () {
        let context = this;
        let args = arguments;

        if (running) return;

        running = true;

        return promised
            .apply(context, args)
            .finally((data) => {
                running = false;
                return data;
            });
    }
};

/**
 * Block an element until a promise be fulfilled
 */
let loyalty = ($el, promise) => {
    $el
      .removeClass('blockable')
      .addClass('blockable')
      .addClass('blocked');

    return promise.then((data) => {
        $el.removeClass('blocked');
        return data;
    }).catch((ex) => {
        $el.removeClass('blocked');
        return ex;
    });
};

// retirado do underscore.js
let range = (start, stop, step) => {
    if (stop == null) {
        stop = start || 0;
        start = 0;
    }

    if (!step) {
        step = stop < start ? -1 : 1;
    }

    let length = Math.max(Math.ceil((stop - start) / step), 0);
    let range = new Array(length);

    for (let idx = 0; idx < length; idx++, start += step) {
        range[idx] = start;
    }

    return range;
};

let first = ([first]) => first;

let last = (array) => array.slice(-1)[0];

let chunk = (array, chunkSize) => {
    let target = [];

    for (let i = 0; i < array.length; i += chunkSize) {
        target.push(array.slice(i, i + chunkSize));
    }

    return target;
};

module.exports = {stripTags, devotion, range, sprintf, first, last, chunk, loyalty};



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/prelude.js